import React from "react";
import {
  TbCalendarEvent,
  TbHeartHandshake,
  TbLink,
  TbMapPin,
  TbPencil,
  TbPhone,
  TbTrash,
} from "react-icons/tb";
import { useToast } from "../../../context/toast-context";
import {
  Button,
  Col,
  FabButton,
  Flex,
  Gap,
  Icon,
  InputField,
  Link,
  Row,
  SelectField,
  Typography,
} from "../../../ppui";
import { formatToCustomDate } from "../../../utils/common";
import { CardViewBox, CardViewBoxBorder, ContentHeading } from "../../style";
import { FAMILY_FORM_FIELDS } from "./family-constant";
const FamilyList = ({
  resource,
  handleClickOpen,
  getInputFieldPropsFn,
  handleSubmitFn,
  setPreviewURL,
  setSelectedFile,
  handleDeleteDialogOpen,
  selectedFile,
}) => {
  const { showToastMessage } = useToast();

  if (!resource) {
    throw new Promise(() => {});
  }
  const familyRes = resource.read();
  const familyInfo = familyRes?.data?.data?.families;

  return (
    <>
      <ContentHeading>
        <Typography variant="h5" mb="0">
          Family Details
        </Typography>
        {familyInfo?.length > 0 && (
          <Button color="primary" variant="contained" onClick={handleClickOpen}>
            Add New
          </Button>
        )}
      </ContentHeading>

      {familyInfo?.length > 0 ? (
        <>
          <Row  rowGap>
            {familyInfo?.map((item) => (
              <>
                <Col sm={12} md={6} lg={6} xl={6} xxl={6}>
                  <CardViewBox>
                    <Row alignItem="center" mb={15} rowGap>
                      <Col>
                        <Typography textCase="capitalize" variant="h6" mb={"0"} strong color="primary">
                          {item?.name ? item?.name : "N/A"}
                        </Typography>

                        <Typography variant="body2" mb={"0"} >
                         Relationship -  {item?.relationship ? item?.relationship : "N/A"}
                        </Typography>



                      </Col>

                      <Col sm={"auto"} ml={"auto"}>
                        <Flex alignItem="center" gap="10">
                          <FabButton
                            size="sm"
                            icon={<TbTrash />}
                            onClick={() =>
                              handleDeleteDialogOpen(item?.family_id)
                            }
                            variant="filled"
                            shape="box"
                          />
                          <FabButton
                            size="sm"
                            icon={<TbPencil />}
                            variant="filled"
                            onClick={() => handleClickOpen(undefined, item)}
                            shape="box"
                          />
                        </Flex>
                      </Col>
                    </Row>
                    <CardViewBoxBorder />


                    <Flex alignItem="center" gap={"5"}>
                      <Icon>
                        <TbCalendarEvent />
                      </Icon>

                      <Typography variant="body2" mb={"0"}>
                        {item?.date_of_birth
                          ? formatToCustomDate(new Date(item?.date_of_birth))
                          : "N/A"}
                      </Typography>
                    </Flex>


                    <Flex alignItem="center" gap={"5"}>
                      <Icon>
                        <TbHeartHandshake />
                      </Icon>

                      <Typography variant="body2" mb={"0"}>
                      {item?.is_depend_on_family ? "Dependent Family Member" : "Not Dependent Family Member"}
                      </Typography>
                    </Flex>


                    <Flex alignItem="center" gap={"5"}>
                      <Icon>
                        {/* <TbMail /> */}
                        <TbPhone />
                      </Icon>

                      <Typography variant="body2" mb={"0"}>
                        {item?.contact_no ? item?.contact_no : "N/A"}
                      </Typography>
                    </Flex>
                    <Flex alignItem="center" gap={"5"}>
                      <Icon>
                        <TbMapPin />
                      </Icon>
                      <Typography variant="body2" mb={"0"}>
                        {item?.address ? item?.address : "N/A"}
                      </Typography>
                    </Flex>
                    {item?.employee_family_file && ( 
                    <Flex alignItem="center" gap={"5"}>
                      <Icon>
                        <TbLink />
                      </Icon>
                      
                      <Typography variant="body1" mb={"0"}>
                        Id Proof - <Link to={item?.employee_family_file} target="blank">View</Link>
                      </Typography>
                        {/* <Button 
                          onClick={() =>
                            window.open(
                              `${item?.employee_family_file}`,
                              "_blank"
                            )
                          }
                          variant="filled"
                          size="sm"
                          color="primary"
                        >
                          View
                        </Button> */}
                    </Flex>
                    )}
                  </CardViewBox>
                </Col>

             
              </>
            ))}
          </Row>
        </>
      ) : (
        <>
          <Row rowGap>
            <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
              <InputField
                {...getInputFieldPropsFn(FAMILY_FORM_FIELDS.name.name)}
              />
            </Col>

            <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
              <SelectField
                {...getInputFieldPropsFn(FAMILY_FORM_FIELDS.relationship.name)}
              />
            </Col>
            <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
              <SelectField
                {...getInputFieldPropsFn(
                  FAMILY_FORM_FIELDS.is_depend_on_family.name
                )}
              />
            </Col>
            <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
              <InputField
                {...getInputFieldPropsFn(FAMILY_FORM_FIELDS.date_of_birth.name)}
                // valueSinc
                // onKeyDown={e=>e.preventDefault()}
              />
            </Col>

            <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
              <InputField
                {...getInputFieldPropsFn(FAMILY_FORM_FIELDS.contact_no.name)}
              />
            </Col>

            <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
              <InputField
                {...getInputFieldPropsFn(FAMILY_FORM_FIELDS.address.name)}
              />
            </Col>

            <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
              <InputField
                type="file"
                fullWidth
                label="ID Proof"
                placeholder="Upload File"
                valueSinc={true}
                helperText={selectedFile?.name}
                onChange={(event) => {
                  const file = event.target.files[0];
                  if (file) {
                    const maxSizeInBytes = 2 * 1024 * 1024;
                    if (file.size > maxSizeInBytes) {
                      showToastMessage({
                        message: "File size should not exceed 2 MB.",
                        color: "danger",
                      });
                      return;
                    }
                    const allowedTypes = [
                      // "image/jpeg",
                      // "image/jpg",
                      // "application/pdf",
                      "image/png",
                    ];

                    if (!allowedTypes.includes(file.type)) {
                      showToastMessage({
                        message: "Only PNG files are allowed.",
                        color: "danger",
                      });
                      return;
                    }
                    setSelectedFile(file);
                    setPreviewURL(URL.createObjectURL(file));
                  }
                }}
              />
            </Col>
          </Row>
          <Gap height={100} />
          <Flex justifyContent="flex-end" gap={"10"}>
            <Button onClick={() => {}} variant="outlined">
              Cancel
            </Button>

            <Button
              color="primary"
              onClick={handleSubmitFn}
              variant="contained"
            >
              Submit
            </Button>
          </Flex>
        </>
      )}
    </>
  );
};

export default FamilyList;
